<template>
  <div
      :class="{ 'md:fixed md:top-0': sticky }"
      class="mx-4 max-w-full rounded-lg bg-white mt-10 mb-6"
  >
    <div class="lg:px-24 bg-origin-padding bg-gradient-to-b md:bg-gradient-chevron from-cal-blue to-cal-light-blue text-white text-center md:pb-3 mb-1 md:mb-4 rounded-tl-lg rounded-tr-lg">
      <div class="p-2 md:p-7 flex flex-row md:flex-col justify-center items-center space-x-2">
        <div v-if="isFreeTrial" class="uppercase">Your free trial plan:</div>
        <div v-else class="uppercase">Your plan:</div>
        <h2 class="uppercase text-2xl md:text-4xl m-0 md:mt-7">{{ planName | planNameFilter }}</h2>
        <p v-if="!isFreeTrial" class="font-bold m-0 p-0 text-2xl">{{ planPrice | priceFormat }}</p>
      </div>
    </div>

	<div v-if="planDescription" class="text-center max-w-md mx-auto">
		<p v-html="planDescription"></p>
	</div>

    <ul class="list-none m-0 p-0 text-center text-cal-blue text-lg w-3/4 mx-auto">
      <li v-if="isFreeTrial && coverageLimit !== 0" class="border-b border-0 border-solid border-gray-300 py-2"></li>
	  <li v-if="!isFreeTrial && usersCount !== 0" class="border-b border-0 border-solid border-gray-300 py-2">{{ usersCount }} Users</li>
      <li v-if="coverageLimit !== 0" class="border-b border-0 border-solid border-gray-300 py-2">{{ coverage }}</li>
	  <li v-if="!isFreeTrial && hasDownload" class="border-b border-0 border-solid border-gray-300 py-2">One-Click Excel Download</li>
      <li v-if="isFreeTrial" class="py-2 grid mt-5">
        <span class="uppercase font-bold text-3xl">Five projects</span>
		<span class="text-sm text-gray-400">No credit card required.</span>
      </li>
      <li v-if="!isFreeTrial" class="font-bold py-2">
        <p><span>Total: </span><span v-bind:class="{ 'line-through': isFreeTrial }">{{ totalPrice | priceFormat }}</span></p>
        <p class="mt-2 text-base text-cal-light-blue">per year</p>
      </li>
    </ul>
    <div class="text-center pb-4 md:py-4">
      <div v-if="!isCompleted">
        <p class="p-0 mt-0 md:mt-2 mb-2 text-cal-blue text-sm">Want to switch plans?</p>
        <div class="inline-block bg-cal-EBEBEB shadow-md rounded-md bg-white px-3 py-1 leading-none align-middle">
          <a class="text-cal-blue font-bold uppercase text-xs no-underline" href="https://constructalead.com/sign-up/">< Back to site</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default {
  props: {
    planName: {
      type: String,
      required: true,
    },
    planPrice: {
      type: String,
      required: true,
    },
    planDescription: {
      type: String,
      default: '',
      required: false,
    },
    totalPrice: {
      type: String,
      required: true,
    },
    usersCount: {
      type: Number,
      required: true,
    },
    coverageType: {
      type: String,
      required: true
    },
    coverageLimit: {
      type: Number,
      required: true
    },
    hasDownload: {
      type: Boolean,
      required: true
    },
    isFreeTrial: {
      type: Boolean,
      default: false,
    },
    isCompleted: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    coverage() {
      if (this.coverageLimit === -1) {
        return 'ALL States & Counties';
      }
      if (this.coverageType === 'vertical_market') {
        if (this.coverageLimit === 1) {
          return '1 Vertical Market';
        }
        return `${this.coverageLimit} Vertical Markets`;
      }
      if (this.coverageType === 'state') {
        if (this.coverageLimit === 1) {
          return '1 State';
        }
        return `${this.coverageLimit} States`;
      }
      return this.coverageLimit + ' Counties';
    },
  },
  filters: {
    planNameFilter(value) {
      return value ? value.replace(' Edition', '') : ''
    },
    priceFormat(value) {
      if (isNaN(value)) {
        return '';
      }
      return value ? formatter.format(value).replace('.00', '') : ''
    }
  },
}
</script>
